import { API } from '@/constants/api';

const redirectToLogout = (): void => {
  window.location.href =
    '/monitoring-api/authenticate/logout/?success_redirect_url=' +
    API.baseUrl +
    'clear/';
};

export { redirectToLogout };
